export const CANADA_PROVINCES = [
  { ID: 1, NAME: "Alberta", CODE: "AB" },
  { ID: 2, NAME: "British Columbia", CODE: "BC" },
  { ID: 3, NAME: "Manitoba", CODE: "MB" },
  { ID: 4, NAME: "New Brunswick", CODE: "NB" },
  { ID: 5, NAME: "Newfoundland and Labrador", CODE: "NL" },
  { ID: 6, NAME: "Nova Scotia", CODE: "NS" },
  { ID: 7, NAME: "Northwest Territories", CODE: "NT" },
  { ID: 8, NAME: "Nunavut", CODE: "NU" },
  { ID: 9, NAME: "Ontario", CODE: "ON" },
  { ID: 10, NAME: "Prince Edward Island", CODE: "PE" },
  { ID: 11, NAME: "Quebec", CODE: "QC" },
  { ID: 12, NAME: "Saskatchewan", CODE: "SK" },
  { ID: 13, NAME: "Yukon Territories", CODE: "YT" },
] as const;

export type ProvinceCode = (typeof CANADA_PROVINCES)[number]["CODE"];
